webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(424),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(2152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_HomePage__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_HomePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_HomePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_security_LoginPage__ = __webpack_require__(2135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_security_LoginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_security_LoginPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_security_ChangePasswordPage__ = __webpack_require__(2134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_security_ChangePasswordPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_security_ChangePasswordPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SQLWorkbenchPage__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SQLWorkbenchPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_SQLWorkbenchPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_FileSystemPage__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_FileSystemPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_FileSystemPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_IconsPage__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_IconsPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_IconsPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_AboutPage__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_AboutPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_AboutPage__);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/**
 * By default the page are public, to secure a page, add the secure property with a value of true as part of the meta property
 *
 * meta: {
 *   secure: false
 * }
 */
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'HomePage',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_HomePage___default.a
  }, {
    path: '/login',
    name: 'LoginPage',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_security_LoginPage___default.a
  }, {
    path: '/user/password',
    name: 'ChangePasswordPage',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_security_ChangePasswordPage___default.a,
    meta: {
      secure: true
    }
  }, {
    path: '/workbench',
    name: 'SQLWorkbenchPage',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_SQLWorkbenchPage___default.a,
    meta: {
      secure: true
    }
  }, {
    path: '/filesystem',
    name: 'FileSystemPage',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_FileSystemPage___default.a,
    meta: {
      secure: true
    }
  }, {
    path: '/icons',
    name: 'IconsPage',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_IconsPage___default.a
  }, {
    path: '/about',
    name: 'AboutPage',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_AboutPage___default.a
  }]
}));

/***/ }),

/***/ 2122:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(2146),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-99654442",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2123:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(2147),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2124:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(2150),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2125:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(552)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(2137),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2126:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(559)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(2143),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6445f2f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2127:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(2145),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-88dea09c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2128:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(2140),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2129:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(2142),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-633b5de6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2130:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(2138),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1ea70079",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2131:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(557)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(2141),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38f75866",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2132:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(551)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(2136),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07e5a39a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2133:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(554)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(2139),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21eedd02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2134:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(560)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(2144),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7018cd9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2135:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(2149),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e59ea270",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 2136:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap"
  }, _vm._l((_vm.icons), function(icon) {
    return _c('span', {
      staticClass: "border m-2 p-2",
      staticStyle: {
        "width": "200px",
        "height": "100px"
      }
    }, [_c('span', {
      staticClass: "d-flex justify-content-center"
    }, [_c('icon', {
      attrs: {
        "name": icon,
        "scale": "2"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "d-flex justify-content-center"
    }, [_vm._v(_vm._s(icon))])])
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2137:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "m-0 p-1",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.status !== 'RUNNING') ? _c('el-tabs', {
    staticClass: "mt-1",
    attrs: {
      "type": "border-card",
      "tab-position": "top"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Sample Data"
    }
  }, [_c('b-row', {
    staticClass: "p-0 m-0"
  }, [_c('b-col', {
    staticClass: "d-flex justify-content-end p-0"
  }, [_c('span', {
    staticClass: "d-inline-flex p-1"
  }, [_c('b-form-select', {
    attrs: {
      "id": "per-page-select"
    },
    model: {
      value: (_vm.table.rowsPerPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "rowsPerPage", $$v)
      },
      expression: "table.rowsPerPage"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 100
    }
  }, [_vm._v("100")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "d-inline-flex p-1"
  }, [_c('b-pagination', {
    attrs: {
      "variant": "outline-secondary",
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.rowsPerPage
    },
    model: {
      value: (_vm.table.pageNo),
      callback: function($$v) {
        _vm.$set(_vm.table, "pageNo", $$v)
      },
      expression: "table.pageNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.status === 'SUCCESS') ? _c('b-table', {
    attrs: {
      "head-variant": "light",
      "no-border-collapse": "",
      "bordered": "",
      "striped": "",
      "hover": "",
      "small": "",
      "sticky-header": "",
      "items": _vm.table.data,
      "fields": _vm.table.fields,
      "current-page": _vm.table.pageNo,
      "per-page": _vm.table.rowsPerPage
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Columns"
    }
  }, [_c('b-row', {
    staticClass: "p-0 m-0"
  }, [_c('b-col', {
    staticClass: "d-flex justify-content-end p-0"
  }, [_c('span', {
    staticClass: "d-inline-flex p-1"
  }, [_c('b-form-select', {
    attrs: {
      "id": "per-page-select"
    },
    model: {
      value: (_vm.columns.rowsPerPage),
      callback: function($$v) {
        _vm.$set(_vm.columns, "rowsPerPage", $$v)
      },
      expression: "columns.rowsPerPage"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 100
    }
  }, [_vm._v("100")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "d-inline-flex p-1"
  }, [_c('b-pagination', {
    attrs: {
      "variant": "outline-secondary",
      "total-rows": _vm.columns.totalRows,
      "per-page": _vm.columns.rowsPerPage
    },
    model: {
      value: (_vm.columns.pageNo),
      callback: function($$v) {
        _vm.$set(_vm.columns, "pageNo", $$v)
      },
      expression: "columns.pageNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.status === 'SUCCESS') ? _c('b-table', {
    attrs: {
      "head-variant": "light",
      "responsive": "",
      "bordered": "",
      "striped": "",
      "hover": "",
      "sticky-header": "",
      "items": _vm.columns.data,
      "fields": _vm.columns.fields,
      "current-page": _vm.columns.pageNo,
      "per-page": _vm.columns.rowsPerPage
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    staticStyle: {
      "height": "260px",
      "overflow": "auto"
    },
    attrs: {
      "label": "Script"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('a-code-editor', {
    staticClass: "m-0 p-0",
    attrs: {
      "lineNumbers": "",
      "readonly": ""
    },
    model: {
      value: (_vm.createTableScript),
      callback: function($$v) {
        _vm.createTableScript = $$v
      },
      expression: "createTableScript"
    }
  })], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2138:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "File System",
      "active": ""
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('a-file-system-explorer')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2139:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "SQL Workbench",
      "active": ""
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-button-toolbar', {
    staticClass: "pb-2",
    attrs: {
      "key-nav": "",
      "aria-label": "Toolbar with button groups"
    }
  }, [_c('b-button-group', {
    staticClass: "mx-1"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.query === '',
      "title": "Execute query"
    },
    on: {
      "click": function($event) {
        return _vm.onExecuteQuery()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "play"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.query === '',
      "title": "Execute count query"
    },
    on: {
      "click": function($event) {
        return _vm.onCountQuery()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "calculator"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.query === '',
      "title": "Prettify SQL"
    },
    on: {
      "click": function($event) {
        return _vm.prettify()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "align-left"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Clear editor"
    },
    on: {
      "click": function($event) {
        return _vm.onClear()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "eraser"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Close all tabs"
    },
    on: {
      "click": function($event) {
        _vm.tabs = []
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "times"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button-group', {
    staticClass: "mx-1"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Sync catalog"
    },
    on: {
      "click": function($event) {
        return _vm.syncCatalog()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "sync"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Show catalog"
    },
    on: {
      "click": function($event) {
        return _vm.onToggleCatalogTree()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "database"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Show saved queries"
    },
    on: {
      "click": function($event) {
        return _vm.onToggleSavedQueries()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-alt"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Switch editors"
    },
    on: {
      "click": function($event) {
        return _vm.onToggleEditor()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('splitpanes', {
    staticClass: "splitpanes",
    staticStyle: {
      "height": "750px"
    },
    on: {
      "resize": function($event) {
        _vm.preferences.catalogPaneSize = $event[0].size
      }
    }
  }, [(_vm.preferences.showCatalogTree) ? _c('pane', {
    staticClass: "p-2",
    staticStyle: {
      "display": "block",
      "overflow": "auto"
    },
    attrs: {
      "size": _vm.preferences.catalogPaneSize
    }
  }, [_c('a-catalog-viewer', {
    on: {
      "tableClicked": _vm.showTable
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('pane', {
    attrs: {
      "size": "70"
    }
  }, [_c('b-container', {
    staticClass: "m-0 p-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('splitpanes', {
    staticClass: "splitpanes",
    staticStyle: {
      "height": "260px"
    },
    attrs: {
      "vertical": ""
    }
  }, [_c('pane', {
    attrs: {
      "size": "70"
    }
  }, [(_vm.preferences.editor === 'classic') ? _c('b-form-textarea', {
    ref: "query",
    staticClass: "text-monospace",
    attrs: {
      "id": "query",
      "type": "text",
      "rows": "10",
      "no-resize": ""
    },
    on: {
      "change": _vm.onQueryChange
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.preferences.editor === 'new') ? _c('a-code-editor', {
    attrs: {
      "lineNumbers": ""
    },
    on: {
      "change": _vm.onQueryChange
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.preferences.showSavedQueries) ? _c('pane', {
    staticClass: "m-0 p-0",
    attrs: {
      "size": "30",
      "min-size": "10"
    }
  }, [_c('a-saved-queries', {
    attrs: {
      "username": "user"
    },
    on: {
      "copyQuery": _vm.onCopyQuery,
      "executeQuery": _vm.onExecuteSavedQuery
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.tabs.length > 0) ? _c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('el-tabs', {
    staticClass: "mt-2",
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('el-tab-pane', {
      key: tab.id,
      staticClass: "p-1",
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [(tab.status !== 'Done') ? _c('b-spinner', {
            attrs: {
              "type": "border",
              "small": ""
            }
          }) : _vm._e(), _vm._v(" "), (tab.status === 'Done') ? _c('span', [(tab.type === 'table') ? _c('icon', {
            attrs: {
              "name": "table"
            }
          }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(tab.name))]), _vm._v(" \n\t\t\t\t\t\t\t\t\t\t"), _c('span', {
            on: {
              "click": function($event) {
                return _vm.deleteTab(tab.id)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times"
            }
          })], 1)]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('b-card-text', [(tab.type === 'query') ? _c('a-query', {
      attrs: {
        "query": tab
      },
      on: {
        "onComplete": _vm.onComplete
      }
    }) : _vm._e(), _vm._v(" "), (tab.type === 'table') ? _c('a-table-info', {
      attrs: {
        "tab": tab
      },
      on: {
        "onComplete": _vm.onComplete
      }
    }) : _vm._e()], 1)], 1)
  }), 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2140:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('prism-editor', {
    staticClass: "code-editor m-0 p-0",
    attrs: {
      "highlight": _vm.highlighter,
      "line-numbers": _vm.lineNumbers,
      "readonly": _vm.readonly
    },
    on: {
      "input": _vm.change
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 2141:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2142:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container'"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Trino Web Console")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Teedrei")]), _vm._v(" "), _c('p', [_vm._v("Created By: "), _c('a', {
    attrs: {
      "href": "https://edwardbiton.teedrei.com"
    }
  }, [_vm._v("Edward Biton")])])])])])])
}]}

/***/ }),

/***/ 2143:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tree', {
    attrs: {
      "id": "1",
      "props": _vm.treeProps,
      "load": _vm.loadNode,
      "lazy": ""
    },
    on: {
      "node-contextmenu": _vm.rightClick
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {
          staticClass: "custom-tree-node"
        }, [(node.level === 1) ? _c('span', {
          staticClass: "no-wrap"
        }, [_c('icon', {
          staticStyle: {
            "color": "777"
          },
          attrs: {
            "name": "atlas"
          }
        }), _vm._v("\n\t\t\t" + _vm._s(data.name) + "\n\t\t")], 1) : _vm._e(), _vm._v(" "), (node.level === 2) ? _c('span', [_c('icon', {
          staticStyle: {
            "color": "777"
          },
          attrs: {
            "name": "database"
          }
        }), _vm._v("\n\t\t\t" + _vm._s(data.name) + "\n\t\t")], 1) : _vm._e(), _vm._v(" "), (node.level === 3) ? _c('span', [(node.data.data.type === 'TABLE') ? [_c('icon', {
          staticStyle: {
            "color": "777"
          },
          attrs: {
            "name": "table"
          }
        })] : _vm._e(), _vm._v(" "), (node.data.data.type === 'VIEW') ? [_c('icon', {
          staticStyle: {
            "color": "777"
          },
          attrs: {
            "name": "eye"
          }
        })] : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(data.name) + "\n\t\t")], 2) : _vm._e(), _vm._v(" "), (node.level === 4) ? _c('a-column-tree-item', {
          attrs: {
            "column": data.data
          }
        }) : _vm._e()], 1)
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 2144:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "User Profile",
      "to": "/user/profile"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Password",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', [_c('b-form', {
    on: {
      "submit": _vm.changePassword
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "oldPassword-group",
      "label": "Current Password:",
      "label-for": "oldPassword",
      "description": "Enter your current password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "oldPassword",
      "type": "password",
      "autofocus": "",
      "required": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "newPassword-group",
      "label": "New Password:",
      "label-for": "newPassword",
      "description": "Enter a new password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "newPassword",
      "type": "password",
      "required": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "verifyPassword-group",
      "label": "Verify Password:",
      "label-for": "verifyPassword",
      "description": "Re-enter new password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "verifyPassword",
      "type": "password",
      "required": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.verifyPassword),
      callback: function($$v) {
        _vm.verifyPassword = $$v
      },
      expression: "verifyPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "type": "Submit",
      "variant": "primary"
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2145:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('icon', {
    staticStyle: {
      "color": "777"
    },
    attrs: {
      "name": _vm.iconName
    }
  }), _vm._v(" " + _vm._s(_vm.displayName) + "\n")], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2146:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('b-input-group', [_c('b-input-group-prepend', [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.home()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "home"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.path.length <= 1
    },
    on: {
      "click": function($event) {
        return _vm.parent()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-left"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "path-id",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter the file system path"
    },
    model: {
      value: (_vm.path),
      callback: function($$v) {
        _vm.path = $$v
      },
      expression: "path"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.pageChange()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "id": "filter-id",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Filter the current folder"
    },
    on: {
      "keyup": function($event) {
        return _vm.filterData()
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "primary"
    }
  }, [_c('icon', {
    attrs: {
      "name": "filter"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-table', {
    attrs: {
      "bordered": "",
      "striped": "",
      "hover": "",
      "responsive": "",
      "fields": _vm.fields,
      "items": _vm.files,
      "current-page": _vm.pageNo,
      "per-page": _vm.rowsPerPage
    },
    on: {
      "row-clicked": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "cell(size)",
      fn: function(file) {
        return [(file.item.folder === false) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("size")(file.item.size)) + " \n\t\t\t\t\t\t"), _c('icon', {
          staticStyle: {
            "color": "#777"
          },
          attrs: {
            "name": "file"
          }
        })], 1) : _vm._e(), _vm._v(" "), (file.item.folder === true) ? _c('span', [_c('icon', {
          staticStyle: {
            "color": "#777"
          },
          attrs: {
            "name": "folder"
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_vm._v("\n\t\t\t" + _vm._s(_vm._f("integer")(_vm.totalRows)) + " Files\n\t\t")]), _vm._v(" "), _c('b-col', {
    staticClass: "d-flex justify-content-end"
  }, [_c('span', {
    staticClass: "d-inline-flex p-2"
  }, [_c('b-form-select', {
    attrs: {
      "id": "per-page-select"
    },
    model: {
      value: (_vm.rowsPerPage),
      callback: function($$v) {
        _vm.rowsPerPage = $$v
      },
      expression: "rowsPerPage"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 100
    }
  }, [_vm._v("100")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "d-inline-flex p-2"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.rowsPerPage
    },
    model: {
      value: (_vm.pageNo),
      callback: function($$v) {
        _vm.pageNo = $$v
      },
      expression: "pageNo"
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2147:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.status === 'FAILED') ? _c('b-row', [_c('b-col', [_c('b-alert', {
    attrs: {
      "show": _vm.status === 'FAILED',
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.status !== 'RUNNING') ? _c('b-row', {
    staticClass: "p-0 m-0"
  }, [_c('b-col', {
    staticClass: "p-0"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.status === 'SUCCESS' && _vm.message !== null,
      "dismissible": "",
      "variant": "warning"
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "d-flex flex-row justify-content-end p-0"
  }, [_c('span', {
    staticClass: "pl-2 bd-highlight"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Save Query"
    },
    on: {
      "click": function($event) {
        _vm.saveDialog.visible = true
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "save"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pl-2 bd-highlight"
  }, [_c('b-form-select', {
    attrs: {
      "id": "per-page-select"
    },
    model: {
      value: (_vm.rowsPerPage),
      callback: function($$v) {
        _vm.rowsPerPage = $$v
      },
      expression: "rowsPerPage"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 20
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 50
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('b-form-select-option', {
    attrs: {
      "value": 100
    }
  }, [_vm._v("100")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pl-2 bd-highlight"
  }, [_c('b-pagination', {
    attrs: {
      "variant": "outline-secondary",
      "total-rows": _vm.totalRows,
      "per-page": _vm.rowsPerPage
    },
    model: {
      value: (_vm.pageNo),
      callback: function($$v) {
        _vm.pageNo = $$v
      },
      expression: "pageNo"
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-skeleton-wrapper', {
    attrs: {
      "loading": _vm.status === 'RUNNING'
    },
    scopedSlots: _vm._u([{
      key: "loading",
      fn: function() {
        return [_c('b-skeleton-table', {
          attrs: {
            "animation": "throb",
            "rows": 5,
            "columns": 4,
            "table-props": {
              hover: true,
              bordered: true,
              striped: true
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_vm._v(" "), (_vm.status === 'SUCCESS') ? _c('b-table', {
    attrs: {
      "head-variant": "light",
      "no-border-collapse": "",
      "bordered": "",
      "striped": "",
      "hover": "",
      "small": "",
      "sticky-header": "",
      "items": _vm.table,
      "fields": _vm.fields,
      "current-page": _vm.pageNo,
      "per-page": _vm.rowsPerPage
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": 'save-dialog-' + _vm.query.id,
      "centered": "",
      "title": "Save Query"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_c('div', {
          staticClass: "w-100"
        }, [_c('p', {
          staticClass: "float-left"
        }), _vm._v(" "), _c('b-button-group', {
          staticClass: "float-right"
        }, [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.saveQuery()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "outline-secondary"
          },
          on: {
            "click": function($event) {
              _vm.saveDialog.visible = false
            }
          }
        }, [_vm._v("Cancel")])], 1)], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.saveDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.saveDialog, "visible", $$v)
      },
      expression: "saveDialog.visible"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "name-id",
      "label": "Name:",
      "label-for": "name",
      "description": "Name the query"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Query Name"
    },
    model: {
      value: (_vm.saveDialog.name),
      callback: function($$v) {
        _vm.$set(_vm.saveDialog, "name", $$v)
      },
      expression: "saveDialog.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "description-id",
      "label": "Description:",
      "label-for": "description",
      "description": "Describe the query"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Query Description",
      "rows": "5"
    },
    model: {
      value: (_vm.saveDialog.description),
      callback: function($$v) {
        _vm.$set(_vm.saveDialog, "description", $$v)
      },
      expression: "saveDialog.description"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2148:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "xl",
      "type": "dark",
      "variant": "dark",
      "sticky": "",
      "fixed": ""
    }
  }, [_c('b-navbar-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(585),
      "height": "32"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), (_vm.authenticationService.isAuthenticated() === true) ? _c('b-nav-item', {
    attrs: {
      "to": "/workbench"
    }
  }, [_vm._v("SQL Workbench")]) : _vm._e(), _vm._v(" "), (_vm.authenticationService.isAuthenticated() === true) ? _c('b-nav-item', {
    attrs: {
      "to": "/filesystem"
    }
  }, [_vm._v("File System")]) : _vm._e()], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.authenticationService.isAuthenticated() === false) ? _c('b-nav-item', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]) : _vm._e(), _vm._v(" "), (_vm.authenticationService.isAuthenticated() === true) ? _c('b-nav-item-dropdown', {
    attrs: {
      "id": "user-dropdown",
      "text": _vm.user.displayName,
      "toggle-class": "nav-link-custom",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function() {
        return [_c('b-img', {
          attrs: {
            "src": _vm.user.imageUrl,
            "rounded": "circle",
            "width": "32"
          }
        }), _vm._v(" " + _vm._s(_vm.user.displayName) + "\r\n\t\t\t\t\t\t")]
      },
      proxy: true
    }], null, false, 2936113834)
  }, [_vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/user/password"
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logout")])], 1) : _vm._e(), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "id": "help-dropdown",
      "text": "Help",
      "toggle-class": "nav-link-custom",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "https://www.teedrei.com",
      "target": "new"
    }
  }, [_vm._v("Documentation")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2149:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "justify-content-md-center"
  }, [_c('b-card', [_c('b-card-body', {
    attrs: {
      "title": "Trino Console"
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.login
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "username-group",
      "label": "Username:",
      "label-for": "username",
      "description": "The username is usually your email address "
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "username",
      "type": "text",
      "autofocus": "",
      "required": "",
      "placeholder": "Enter username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "password-group",
      "label": "Password:",
      "label-for": "password",
      "description": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "password",
      "type": "password",
      "required": "",
      "placeholder": "Enter password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 2150:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-fill"
  }, [_c('b-list-group', {
    staticClass: "d-flex flex-fill",
    staticStyle: {
      "overflow-y": "scroll",
      "height": "258px"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('b-list-group-item', {
      key: item.id,
      staticClass: "flex-column align-items-start p-2"
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('h6', {
      staticClass: "mb-0"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("since")(item.updatedTimestamp)))])]), _vm._v(" "), _c('p', {
      staticClass: "text-monospace"
    }, [_vm._v(_vm._s(_vm._f("ellipsis")(item.query, 50)))]), _vm._v(" "), _c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('small', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('span', [_c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "m-0 p-0",
      attrs: {
        "variant": "link",
        "title": "Delete this query"
      },
      on: {
        "click": function($event) {
          return _vm.deleteQuery(item.id)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "777"
      },
      attrs: {
        "name": "trash"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "m-0 p-0",
      attrs: {
        "variant": "link",
        "title": "Copy the query into the workbench"
      },
      on: {
        "click": function($event) {
          return _vm.copyQuery(item)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "777"
      },
      attrs: {
        "name": "clone"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "m-0 p-0",
      attrs: {
        "variant": "link",
        "title": "Execute this query"
      },
      on: {
        "click": function($event) {
          return _vm.executeQuery(item)
        }
      }
    }, [_c('icon', {
      staticStyle: {
        "color": "777"
      },
      attrs: {
        "name": "play"
      }
    })], 1)], 1)])])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_splitpanes__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_splitpanes_dist_splitpanes_css__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_splitpanes_dist_splitpanes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_splitpanes_dist_splitpanes_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_prism_editor__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Query__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TableInfo__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TableInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_TableInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SavedQueries__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SavedQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SavedQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FileSystemExplorer__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FileSystemExplorer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_FileSystemExplorer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_catalog_CatalogViewer__ = __webpack_require__(2126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_catalog_CatalogViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_catalog_CatalogViewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_catalog_ColumnTreeItem__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_catalog_ColumnTreeItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_catalog_ColumnTreeItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_editor_CodeEditor__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_editor_CodeEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_editor_CodeEditor__);
















/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('prism-editor', __WEBPACK_IMPORTED_MODULE_6_vue_prism_editor__["a" /* PrismEditor */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('a-query', __WEBPACK_IMPORTED_MODULE_7__components_Query___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('a-table-info', __WEBPACK_IMPORTED_MODULE_8__components_TableInfo___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('a-saved-queries', __WEBPACK_IMPORTED_MODULE_9__components_SavedQueries___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('a-file-system-explorer', __WEBPACK_IMPORTED_MODULE_10__components_FileSystemExplorer___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('a-catalog-viewer', __WEBPACK_IMPORTED_MODULE_11__components_catalog_CatalogViewer___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('a-column-tree-item', __WEBPACK_IMPORTED_MODULE_12__components_catalog_ColumnTreeItem___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('a-code-editor', __WEBPACK_IMPORTED_MODULE_13__components_editor_CodeEditor___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Tree"].name, __WEBPACK_IMPORTED_MODULE_1_element_ui__["Tree"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Tabs"].name, __WEBPACK_IMPORTED_MODULE_1_element_ui__["Tabs"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_1_element_ui__["TabPane"].name, __WEBPACK_IMPORTED_MODULE_1_element_ui__["TabPane"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('splitpanes', __WEBPACK_IMPORTED_MODULE_2_splitpanes__["a" /* Splitpanes */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('pane', __WEBPACK_IMPORTED_MODULE_2_splitpanes__["b" /* Pane */]);

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);


var numeral = __webpack_require__(573);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('currency', function (value) {
  return numeral(value).format('0,0.00'); // displaying other groupings/separators is possible, look at the docs
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('percentage', function (value) {
  return numeral(value).format('0,0.00') + '%'; // displaying other groupings/separators is possible, look at the docs
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('integer', function (value) {
  return numeral(value).format('0,0'); // displaying other groupings/separators is possible, look at the docs
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('size', function (value) {
  var divisor = 1;
  var suffix = '';
  if (value > 1099511627776) {
    divisor = 1099511627776;
    suffix = 'tb';
  } else if (value > 1073741824) {
    divisor = 1073741824;
    suffix = 'gb';
  } else if (value > 1048576) {
    divisor = 1048576;
    suffix = ' mb';
  } else if (value > 1024) {
    divisor = 1024;
    suffix = ' kb';
  }
  return (value / divisor).toFixed(2) + suffix;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('since', function (dateString) {
  var dateValue = Date.parse(dateString);
  var now = new Date();
  var difference = now.getTime() - dateValue;
  var divisor = 1;
  var suffix = '';
  if (difference > 31536000000) {
    divisor = 31536000000;
    suffix = 'year';
  } else if (difference > 31536000000) {
    divisor = 31536000000;
    suffix = 'month';
  } else if (difference > 31536000000) {
    divisor = 31536000000;
    suffix = ' week';
  } else if (difference > 86400000) {
    divisor = 86400000;
    suffix = ' day';
  } else if (difference > 3600000) {
    divisor = 3600000;
    suffix = ' hour';
  } else if (difference > 60000) {
    divisor = 60000;
    suffix = ' minute';
  } else if (difference > 1000) {
    divisor = 1000;
    suffix = ' second';
  }
  var displayValue = (difference / divisor).toFixed(0);
  if (displayValue > 1) {
    suffix = suffix + 's';
  }
  return displayValue + suffix + ' ago';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('ellipsis', function (value, limit) {
  if (value.length > limit) {
    return value.substring(0, limit - 3) + '...';
  } else {
    return value;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$filters = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].options.filters;

/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_AuthenticationService__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(115);


/**
 * This code will check if the page is secure and redirect the user to the login page if the user have not logged-in
 */
__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].beforeEach(function (to, from, next) {
  console.log('router: ' + to.path + ' secure=' + to.meta.secure);
  if (to.meta.secure) {
    // console.log('router: page is secure, checking if user has authenticated')
    if (__WEBPACK_IMPORTED_MODULE_0__services_AuthenticationService__["a" /* authenticationService */].isAuthenticated() === false) {
      // console.log('router: User has not authenticated, redirecting to login page at /login')
      next('/login');
      return;
    }
  }
  next();
});

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(2148),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_prism_editor_dist_prismeditor_min_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_prism_editor_dist_prismeditor_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_prism_editor_dist_prismeditor_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters_js__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__route_security_js__ = __webpack_require__(377);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    title: String,
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String,
    tabindex: [Number, String]
  },
  data: function data() {
    return {
      id: getId(),
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    },
    focusable: function focusable() {
      var tabindex = this.tabindex;

      if (tabindex == null) {
        return 'false';
      }
      var index = typeof tabindex === 'string' ? parseInt(tabindex, 10) : tabindex;
      if (index >= 0) {
        return null;
      }
      return 'false';
    }
  },
  mounted: function mounted() {
    this.updateStack();
  },
  updated: function updated() {
    this.updateStack();
  },

  methods: {
    updateStack: function updateStack() {
      var _this = this;

      if (!this.name && this.name !== null && this.$children.length === 0) {
        console.warn('Invalid prop: prop "name" is required.');
        return;
      }

      if (this.icon) {
        return;
      }

      var width = 0;
      var height = 0;
      this.$children.forEach(function (child) {
        child.outerScale = _this.normalizedScale;

        width = Math.max(width, child.width);
        height = Math.max(height, child.height);
      });
      this.childrenWidth = width;
      this.childrenHeight = height;
      this.$children.forEach(function (child) {
        child.x = (width - child.width) / 2;
        child.y = (height - child.height) / 2;
      });
    }
  },
  render: function render(h) {
    if (this.name === null) {
      return h();
    }

    var options = {
      class: this.klass,
      style: this.style,
      attrs: {
        role: this.$attrs.role || (this.label || this.title ? 'img' : null),
        'aria-label': this.label || null,
        'aria-hidden': String(!(this.label || this.title)),
        tabindex: this.tabindex,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        viewBox: this.box,
        focusable: this.focusable
      }
    };

    var titleId = 'vat-' + this.id;
    if (this.title) {
      options.attrs['aria-labelledby'] = titleId;
    }

    if (this.raw) {
      var html = this.raw;

      if (this.title) {
        html = '<title id="' + titleId + '">' + escapeHTML(this.title) + '</title>' + html;
      }

      options.domProps = {
        innerHTML: html
      };
    }

    var content = this.title ? [h('title', { attrs: { id: titleId } }, this.title)] : [];

    return h('svg', options, this.raw ? null : content.concat(this.$slots.default || [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.paths.map(function (path, i) {
      return h('path', {
        attrs: path,
        key: 'path-' + i
      });
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.icon.polygons.map(function (polygon, i) {
      return h('polygon', {
        attrs: polygon,
        key: 'polygon-' + i
      });
    })))));
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];
      var _icon$paths = icon.paths,
          paths = _icon$paths === undefined ? [] : _icon$paths,
          d = icon.d,
          _icon$polygons = icon.polygons,
          polygons = _icon$polygons === undefined ? [] : _icon$polygons,
          points = icon.points;


      if (d) {
        paths.push({ d: d });
      }

      if (points) {
        polygons.push({ points: points });
      }

      icons[name] = assign({}, icon, {
        paths: paths,
        polygons: polygons
      });
    }
  },

  icons: icons
});

function assign(obj) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        obj[key] = source[key];
      }
    }
  });

  return obj;
}

var cursor = 0xd4937;
function getId() {
  return 'va-' + (cursor++).toString(16);
}

var ESCAPE_MAP = {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
};

function escapeHTML(html) {
  return html.replace(/[<>"&]/g, function (c) {
    return ESCAPE_MAP[c] || c;
  });
}

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(115);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      authenticationService: __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__["a" /* authenticationService */]
    };
  },
  computed: {
    user: function user() {
      return __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__["a" /* authenticationService */].getUser();
    }
  },
  methods: {
    logout: function logout() {
      __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__["a" /* authenticationService */].logout();
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/login');
    }
  }
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_HttpService__ = __webpack_require__(51);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'console',
  data: function data() {
    return {
      path: '/',
      filter: '',
      allFiles: [],
      files: [],
      fields: [{
        key: 'size',
        sortable: true,
        tdClass: 'text-right'
      }, {
        key: 'name',
        sortable: true
      }, {
        key: 'permission'
      }, {
        key: 'owner',
        sortable: true
      }, {
        key: 'group',
        sortable: true
      }, {
        key: 'replication',
        sortable: true
      }, {
        key: 'accessTime',
        sortable: true
      }, {
        key: 'modificationTime',
        sortable: true
      }],
      table: [],
      pageOptions: [10, 20, 50, {
        value: 100, text: 'Show a lot'
      }],
      pageNo: 1,
      totalRows: 0,
      rowsPerPage: 10
    };
  },
  methods: {
    pageChange: function pageChange() {
      var _this = this;

      if (this.path === '') {
        this.path = '/';
      }
      __WEBPACK_IMPORTED_MODULE_1__services_HttpService__["a" /* HTTP */].get('api/filesystem', {
        params: {
          path: this.path
        }
      }).then(function (response) {
        _this.allFiles = response.data;
        _this.files = response.data;
        _this.totalRows = _this.files.length;
      });
    },
    filterData: function filterData() {
      if (this.filter === '') {
        this.files = this.allFiles;
        this.totalRows = this.files.length;
        return;
      }
      this.files = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.allFiles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var file = _step.value;

          var text = file.name.toLowerCase();
          console.log(text);
          if (text.indexOf(this.filter) >= 0) {
            this.files.push(file);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.totalRows = this.files.length;
      this.pageNo = 1;
      return this.files;
    },
    home: function home() {
      this.path = '/';
      this.pageChange();
    },
    parent: function parent() {
      var parentPath = this.path.trim();
      if (parentPath === '/') {
        return;
      }
      var index = parentPath.lastIndexOf('/');
      parentPath = parentPath.substring(0, index + 1);
      if (parentPath.endsWith('/') && parentPath !== '/') {
        parentPath = parentPath.substring(0, parentPath.length - 1);
      }
      this.path = parentPath;
      this.pageChange();
    },
    openFolder: function openFolder(fullPath) {
      this.path = fullPath;
      this.pageChange();
    },
    onRowClick: function onRowClick(item, index, event) {
      if (item.folder === true) {
        this.openFolder(item.fullPath);
      }
    }
  },
  created: function created() {
    console.log('here');
    this.pageChange();
  }
});

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_HttpService__ = __webpack_require__(51);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'query',
  props: {
    query: Object
  },
  data: function data() {
    return {
      status: 'RUNNING',
      fields: [],
      table: [],
      pageNo: 1,
      totalRows: 0,
      rowsPerPage: 20,
      message: null,
      saveDialog: {
        visible: false,
        name: '',
        description: ''
      }
    };
  },

  mounted: function mounted() {},
  methods: {
    executeQuery: function executeQuery() {
      var _this = this;

      console.log('Executing Query for TAB: ' + this.query.id);
      this.query.status = 'Running';
      var formData = new FormData();
      formData.append('query', this.query.sql);
      __WEBPACK_IMPORTED_MODULE_1__services_HttpService__["a" /* HTTP */].post('api/query/execute', formData).then(function (response) {
        console.log('Processing response');
        var result = response.data;
        _this.status = result.status;
        _this.message = result.error;
        if (result.status === 'FAILED') {
          _this.query.status = 'Done';
          _this.error = result.error;
          console.log('Status=' + _this.status);
          console.log('Error=' + _this.error);
          _this.$emit('onComplete', _this.query.id);
          return;
        }
        var table = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var row = _step.value;

            var tableRow = {};
            for (var cell in row) {
              var key = result.columns[cell].name;
              var value = row[cell];
              tableRow[key] = value;
            }
            // console.log(tableRow)
            table.push(tableRow);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        console.log('Setting table data');
        var fields = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.columns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var column = _step2.value;

            var tdClass = 'text-nowrap';
            switch (column.dataTypeText) {
              case 'INTEGER':
              case 'BIGINT':
              case 'DOUBLE':
              case 'FLOAT':
              case 'DECIMAL':
                tdClass += ' text-right';
                break;
              case 'TIMESTAMP':
              case 'DATE':
                tdClass += ' text-center';
                break;
            }
            var field = {
              key: column.name,
              label: column.name,
              headerTitle: column.name,
              sortable: true,
              thClass: 'text-center',
              tdClass: tdClass
            };
            fields.push(field);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this.fields = fields;
        _this.totalRows = table.length;
        _this.table = table;
        _this.query.status = 'Done';
        console.log('Done');
        _this.$emit('onComplete', _this.query.id);
      });
    },
    saveQuery: function saveQuery() {
      var _this2 = this;

      var formData = new FormData();
      formData.append('name', this.saveDialog.name);
      formData.append('description', this.saveDialog.description);
      formData.append('sql', this.query.sql);
      __WEBPACK_IMPORTED_MODULE_1__services_HttpService__["a" /* HTTP */].post('api/queries', formData).then(function (response) {
        _this2.saveDialog.visible = false;
        _this2.name = '';
        _this2.description = '';
      });
    }
  },
  created: function created() {
    this.executeQuery();
  }
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(51);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'saved-queries',
  props: {
    username: String
  },
  data: function data() {
    return {
      fields: [],
      items: [],
      pageNo: 1,
      totalRows: 0,
      rowsPerPage: 20
    };
  },

  mounted: function mounted() {},
  methods: {
    pageChange: function pageChange() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('api/queries', {
        params: {
          page: this.pageNo - 1,
          rowsPerPage: this.rowsPerPage
        }
      }).then(function (response) {
        _this.items = response.data.list;
        _this.rowsPerPage = response.data.rowsPerPage;
        _this.totalItems = response.data.totalItems;
      });
    },
    deleteQuery: function deleteQuery(queryId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].delete('api/queries/' + queryId).then(function (response) {
        _this2.pageChange();
      });
    },
    executeQuery: function executeQuery(item) {
      console.log(item);
      this.$emit('executeQuery', item);
    },
    copyQuery: function copyQuery(item) {
      console.log(item);
      this.$emit('copyQuery', item);
    }
  },
  created: function created() {
    this.pageChange();
  }
});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_HttpService__ = __webpack_require__(51);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'table-info',
  props: {
    tab: Object
  },
  data: function data() {
    return {
      status: 'RUNNING',
      createTableScript: '',
      rowsCount: 0,
      table: {
        fields: [],
        data: [],
        pageNo: 1,
        totalRows: 0,
        rowsPerPage: 20
      },
      columns: {
        fields: [{
          key: 'name',
          label: 'Column Name',
          headerTitle: 'Column Name',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-left'
        }, {
          key: 'dataTypeText',
          label: 'Data Type',
          headerTitle: 'Data Type',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-left'
        }, {
          key: 'columnSize',
          label: 'Size',
          headerTitle: 'Size',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-right'
        }, {
          key: 'decimalSize',
          label: 'Precision',
          headerTitle: 'Precision',
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-right'
        }],
        data: [],
        pageNo: 1,
        totalRows: 0,
        rowsPerPage: 20
      }
    };
  },

  mounted: function mounted() {},
  methods: {
    getTableDetails: function getTableDetails() {
      var _this = this;

      console.log(this.tab);
      console.log('Executing Query for TAB: ' + this.tab.id);
      this.table.status = 'Running';
      __WEBPACK_IMPORTED_MODULE_1__services_HttpService__["a" /* HTTP */].get('api/metadata/catalogs/123/schemas/123/tables/' + this.tab.tableId).then(function (response) {
        console.log('Processing response');
        var result = response.data;
        var tableData = [];
        console.log('Setting table data');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var row = _step.value;

            var tableRow = {};
            for (var cell in row) {
              var key = result.columns[cell].name;
              var value = row[cell];
              tableRow[key] = value;
            }
            // console.log(tableRow)
            tableData.push(tableRow);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var fields = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.columns), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var column = _step2.value;

            var tdClass = 'text-nowrap';
            switch (column.dataTypeText) {
              case 'INTEGER':
              case 'BIGINT':
              case 'DOUBLE':
              case 'FLOAT':
              case 'DECIMAL':
                tdClass += ' text-right';
                break;
              case 'TIMESTAMP':
              case 'DATE':
                tdClass += ' text-center';
                break;
            }
            var field = {
              key: column.name,
              label: column.name,
              headerTitle: column.name,
              sortable: true,
              thClass: 'text-center',
              tdClass: tdClass
            };
            fields.push(field);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        _this.table.fields = fields;
        _this.table.totalRows = tableData.length;
        _this.table.data = tableData;
        // setting the columns table
        _this.columns.data = result.columns;
        _this.columns.totalRows = result.columns.length;
        _this.tab.status = 'Done';
        _this.status = 'SUCCESS';
        _this.createTableScript = result.createTableScript;
        _this.$emit('onComplete', _this.tab.id);
      });
    }
  },
  created: function created() {
    this.getTableDetails();
  }
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(51);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'catalog-viewer',
  data: function data() {
    return {
      root: {},
      treeProps: {
        isLeaf: 'leaf'
      },
      catalogs: []
    };
  },

  mounted: function mounted() {},
  methods: {
    rightClick: function rightClick(event, node, nodeProperty, nodeTree) {
      if (node.data.type === 'TABLE') {
        this.$emit('tableClicked', node.data);
      }
    },
    loadNode: function loadNode(node, resolve) {
      switch (node.level) {
        case 0:
          // catalog level
          this.root = node;
          this.loadCatalogs(resolve);
          break;
        case 1:
          // schema level
          this.loadSchemas(node.data.id, resolve);
          break;
        case 2:
          // table level
          this.loadTables(node.parent.data.id, node.data.id, resolve);
          break;
        case 3:
          // column level
          this.loadColumns(node.parent.parent.data.id, node.parent.data.id, node.data.id, resolve);
          break;
      }
      resolve([]);
    },
    loadCatalogs: function loadCatalogs(resolve) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('api/metadata/catalogs', {
        params: {
          page: 0,
          rowsPerPage: 100000,
          search: ''
        }
      }).then(function (response) {
        _this.catalogs = response.data.list;
        var nodes = [];
        _this.catalogs.forEach(function (catalog) {
          var node = {
            id: catalog.id,
            name: catalog.name,
            label: catalog.name,
            data: catalog,
            leaf: false
          };
          nodes.push(node);
        });
        resolve(nodes);
      });
    },
    loadSchemas: function loadSchemas(catalogId, resolve) {
      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('api/metadata/catalogs/' + catalogId + '/schemas', {
        params: {
          page: 0,
          rowsPerPage: 100000,
          search: ''
        }
      }).then(function (response) {
        var schemas = response.data.list;
        var nodes = [];
        schemas.forEach(function (schema) {
          var node = {
            id: schema.id,
            name: schema.name,
            label: schema.name,
            data: schema,
            leaf: false
          };
          nodes.push(node);
        });
        resolve(nodes);
      });
    },
    loadTables: function loadTables(catalogId, schemaId, resolve) {
      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('api/metadata/catalogs/' + catalogId + '/schemas/' + schemaId + '/tables', {
        params: {
          page: 0,
          rowsPerPage: 100000,
          search: ''
        }
      }).then(function (response) {
        var tables = response.data.list;
        var nodes = [];
        tables.forEach(function (table) {
          var node = {
            id: table.id,
            name: table.name,
            label: table.name,
            data: table,
            leaf: false
          };
          nodes.push(node);
        });
        resolve(nodes);
      });
    },
    loadColumns: function loadColumns(catalogId, schemaId, tableId, resolve) {
      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].get('api/metadata/catalogs/' + catalogId + '/schemas/' + schemaId + '/tables/' + tableId + '/columns', {
        params: {
          page: 0,
          rowsPerPage: 100000,
          search: ''
        }
      }).then(function (response) {
        var columns = response.data.list;
        var nodes = [];
        columns.forEach(function (column) {
          var node = {
            id: column.id,
            name: column.name,
            label: column.name,
            data: column,
            leaf: true
          };
          nodes.push(node);
        });
        resolve(nodes);
      });
    }
  },
  updated: function updated() {
    this.root.loaded = false;
    this.root.expand();
  }
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'column-tree-item',
  props: {
    column: Object,
    showType: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted() {},
  computed: {
    displayName: function displayName() {
      if (this.showType === false) {
        return this.column.name;
      }
      var displayName = this.column.name + ' - ' + this.column.dataTypeText;
      switch (this.column.dataTypeText) {
        case 'CHAR':
        case 'VARCHAR':
        case 'LONGVARCHAR':
          if (this.column.columnSize !== 2147483647) {
            displayName = displayName + '(' + this.column.columnSize + ')';
          }
          break;
      }
      return displayName;
    },
    iconName: function iconName() {
      switch (this.column.dataTypeText) {
        case 'CHAR':
        case 'VARCHAR':
        case 'LONGVARCHAR':
          return 'quote-right';
        case 'SMALLINT':
        case 'INTEGER':
        case 'BIGINT':
          return 'hashtag';
        case 'REAL':
        case 'DECIMAL':
        case 'DOUBLE':
          return 'crosshairs';
        case 'TIME':
        case 'TIMESTAMP':
          return 'clock';
        case 'DATE':
          return 'calendar-alt';
      }
      return 'columns';
    }
  }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_components_prism_clike__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_components_prism_clike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismjs_components_prism_clike__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs_components_prism_javascript__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs_components_prism_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prismjs_components_prism_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_components_prism_java__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_components_prism_java___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prismjs_components_prism_java__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prismjs_components_prism_sql__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prismjs_components_prism_sql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prismjs_components_prism_sql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismjs_themes_prism_eclipse_css__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismjs_themes_prism_eclipse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prismjs_themes_prism_eclipse_css__);
//
//
//
//







// import syntax highlighting styles
// import 'prismjs/themes/prism.css'
// import 'prismjs/themes/prism-coy.css
// import 'prismjs/themes/prism-dark.css'
// import 'prismjs/themes/prism-okaidia.css'
// import 'prismjs/themes/prism-solarizedlight.css'
// import 'prismjs/themes/prism-tomorrow.css'
// import 'prismjs/themes/prism-twilight.css'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'd-code-editor',
  props: {
    value: String,
    lineNumbers: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      code: null
    };
  },

  mounted: function mounted() {
    this.code = this.value;
  },
  methods: {
    highlighter: function highlighter(code) {
      // languages.<insert language> to return html with markup
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__["highlight"])(code, __WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__["languages"].sql);
    },
    change: function change() {
      this.$emit('input', this.code);
      this.$emit('change', this.code);
    }
  },
  watch: {
    value: function value(val) {
      this.code = this.value;
    }
  }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'file-system-page',
  data: function data() {
    return {};
  },
  methods: {},
  created: function created() {}
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      icons: ['ad', 'address-book', 'address-card', 'adjust', 'air-freshener', 'align-center', 'align-justify', 'align-left', 'align-right', 'allergies', 'ambulance', 'american-sign-language-interpreting', 'anchor', 'angle-double-down', 'angle-double-left', 'angle-double-right', 'angle-double-up', 'angle-down', 'angle-left', 'angle-right', 'angle-up', 'angry', 'ankh', 'apple-alt', 'archive', 'archway', 'arrow-alt-circle-down', 'arrow-alt-circle-left', 'arrow-alt-circle-right', 'arrow-alt-circle-up', 'arrow-circle-down', 'arrow-circle-left', 'arrow-circle-right', 'arrow-circle-up', 'arrow-down', 'arrow-left', 'arrow-right', 'arrow-up', 'arrows-alt-h', 'arrows-alt-v', 'arrows-alt', 'assistive-listening-systems', 'asterisk', 'at', 'atlas', 'atom', 'audio-description', 'award', 'baby-carriage', 'baby', 'backspace', 'backward', 'bacon', 'balance-scale-left', 'balance-scale-right', 'balance-scale', 'ban', 'band-aid', 'barcode', 'bars', 'baseball-ball', 'basketball-ball', 'bath', 'battery-empty', 'battery-full', 'battery-half', 'battery-quarter', 'battery-three-quarters', 'bed', 'beer', 'bell-slash', 'bell', 'bezier-curve', 'bible', 'bicycle', 'biking', 'binoculars', 'biohazard', 'birthday-cake', 'blender-phone', 'blender', 'blind', 'blog', 'bold', 'bolt', 'bomb', 'bone', 'bong', 'book-dead', 'book-medical', 'book-open', 'book-reader', 'book', 'bookmark', 'border-all', 'border-none', 'border-style', 'bowling-ball', 'box-open', 'box', 'boxes', 'braille', 'brain', 'brands', 'bread-slice', 'briefcase-medical', 'briefcase', 'broadcast-tower', 'broom', 'brush', 'bug', 'building', 'bullhorn', 'bullseye', 'burn', 'bus-alt', 'bus', 'business-time', 'calculator', 'calendar-alt', 'calendar-check', 'calendar-day', 'calendar-minus', 'calendar-plus', 'calendar-times', 'calendar-week', 'calendar', 'camera-retro', 'camera', 'campground', 'candy-cane', 'cannabis', 'capsules', 'car-alt', 'car-battery', 'car-crash', 'car-side', 'car', 'caret-down', 'caret-left', 'caret-right', 'caret-square-down', 'caret-square-left', 'caret-square-right', 'caret-square-up', 'caret-up', 'carrot', 'cart-arrow-down', 'cart-plus', 'cash-register', 'cat', 'certificate', 'chair', 'chalkboard-teacher', 'chalkboard', 'charging-station', 'chart-area', 'chart-bar', 'chart-line', 'chart-pie', 'check-circle', 'check-double', 'check-square', 'check', 'cheese', 'chess-bishop', 'chess-board', 'chess-king', 'chess-knight', 'chess-pawn', 'chess-queen', 'chess-rook', 'chess', 'chevron-circle-down', 'chevron-circle-left', 'chevron-circle-right', 'chevron-circle-up', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'child', 'church', 'circle-notch', 'circle', 'city', 'clinic-medical', 'clipboard-check', 'clipboard-list', 'clipboard', 'clock', 'clone', 'closed-captioning', 'cloud-download-alt', 'cloud-meatball', 'cloud-moon-rain', 'cloud-moon', 'cloud-rain', 'cloud-showers-heavy', 'cloud-sun-rain', 'cloud-sun', 'cloud-upload-alt', 'cloud', 'cocktail', 'code-branch', 'code', 'coffee', 'cog', 'cogs', 'coins', 'columns', 'comment-alt', 'comment-dollar', 'comment-dots', 'comment-medical', 'comment-slash', 'comment', 'comments-dollar', 'comments', 'compact-disc', 'compass', 'compress-arrows-alt', 'compress', 'concierge-bell', 'cookie-bite', 'cookie', 'copy', 'copyright', 'couch', 'credit-card', 'crop-alt', 'crop', 'cross', 'crosshairs', 'crow', 'crown', 'crutch', 'cube', 'cubes', 'cut', 'database', 'deaf', 'democrat', 'desktop', 'dharmachakra', 'diagnoses', 'dice-d20', 'dice-d6', 'dice-five', 'dice-four', 'dice-one', 'dice-six', 'dice-three', 'dice-two', 'dice', 'digital-tachograph', 'directions', 'divide', 'dizzy', 'dna', 'dog', 'dollar-sign', 'dolly-flatbed', 'dolly', 'donate', 'door-closed', 'door-open', 'dot-circle', 'dove', 'download', 'drafting-compass', 'dragon', 'draw-polygon', 'drum-steelpan', 'drum', 'drumstick-bite', 'dumbbell', 'dumpster-fire', 'dumpster', 'dungeon', 'edit', 'egg', 'eject', 'ellipsis-h', 'ellipsis-v', 'envelope-open-text', 'envelope-open', 'envelope-square', 'envelope', 'equals', 'eraser', 'ethernet', 'euro-sign', 'exchange-alt', 'exclamation-circle', 'exclamation-triangle', 'exclamation', 'expand-arrows-alt', 'expand', 'external-link-alt', 'external-link-square-alt', 'eye-dropper', 'eye-slash', 'eye', 'fan', 'fast-backward', 'fast-forward', 'fax', 'feather-alt', 'feather', 'female', 'fighter-jet', 'file-alt', 'file-archive', 'file-audio', 'file-code', 'file-contract', 'file-csv', 'file-download', 'file-excel', 'file-export', 'file-image', 'file-import', 'file-invoice-dollar', 'file-invoice', 'file-medical-alt', 'file-medical', 'file-pdf', 'file-powerpoint', 'file-prescription', 'file-signature', 'file-upload', 'file-video', 'file-word', 'file', 'fill-drip', 'fill', 'film', 'filter', 'fingerprint', 'fire-alt', 'fire-extinguisher', 'fire', 'first-aid', 'fish', 'fist-raised', 'flag-checkered', 'flag-usa', 'flag', 'flask', 'flushed', 'folder-minus', 'folder-open', 'folder-plus', 'folder', 'font', 'football-ball', 'forward', 'frog', 'frown-open', 'frown', 'funnel-dollar', 'futbol', 'gamepad', 'gas-pump', 'gavel', 'gem', 'genderless', 'ghost', 'gift', 'gifts', 'glass-cheers', 'glass-martini-alt', 'glass-martini', 'glass-whiskey', 'glasses', 'globe-africa', 'globe-americas', 'globe-asia', 'globe-europe', 'globe', 'golf-ball', 'gopuram', 'graduation-cap', 'greater-than-equal', 'greater-than', 'grimace', 'grin-alt', 'grin-beam-sweat', 'grin-beam', 'grin-hearts', 'grin-squint-tears', 'grin-squint', 'grin-stars', 'grin-tears', 'grin-tongue-squint', 'grin-tongue-wink', 'grin-tongue', 'grin-wink', 'grin', 'grip-horizontal', 'grip-lines-vertical', 'grip-lines', 'grip-vertical', 'guitar', 'h-square', 'hamburger', 'hammer', 'hamsa', 'hand-holding-heart', 'hand-holding-usd', 'hand-holding', 'hand-lizard', 'hand-middle-finger', 'hand-paper', 'hand-peace', 'hand-point-down', 'hand-point-left', 'hand-point-right', 'hand-point-up', 'hand-pointer', 'hand-rock', 'hand-scissors', 'hand-spock', 'hands-helping', 'hands', 'handshake', 'hanukiah', 'hard-hat', 'hashtag', 'hat-wizard', 'haykal', 'hdd', 'heading', 'headphones-alt', 'headphones', 'headset', 'heart-broken', 'heart', 'heartbeat', 'helicopter', 'highlighter', 'hiking', 'hippo', 'history', 'hockey-puck', 'holly-berry', 'home', 'horse-head', 'horse', 'hospital-alt', 'hospital-symbol', 'hospital', 'hot-tub', 'hotdog', 'hotel', 'hourglass-end', 'hourglass-half', 'hourglass-start', 'hourglass', 'house-damage', 'hryvnia', 'i-cursor', 'ice-cream', 'icicles', 'icons', 'icons.txt', 'id-badge', 'id-card-alt', 'id-card', 'igloo', 'image', 'images', 'inbox', 'indent', 'index', 'industry', 'infinity', 'info-circle', 'info', 'italic', 'jedi', 'joint', 'journal-whills', 'kaaba', 'key', 'keyboard', 'khanda', 'kiss-beam', 'kiss-wink-heart', 'kiss', 'kiwi-bird', 'landmark', 'language', 'laptop-code', 'laptop-medical', 'laptop', 'laugh-beam', 'laugh-squint', 'laugh-wink', 'laugh', 'layer-group', 'leaf', 'lemon', 'less-than-equal', 'less-than', 'level-down-alt', 'level-up-alt', 'life-ring', 'lightbulb', 'link', 'lira-sign', 'list-alt', 'list-ol', 'list-ul', 'list', 'location-arrow', 'lock-open', 'lock', 'long-arrow-alt-down', 'long-arrow-alt-left', 'long-arrow-alt-right', 'long-arrow-alt-up', 'low-vision', 'luggage-cart', 'magic', 'magnet', 'mail-bulk', 'male', 'map-marked-alt', 'map-marked', 'map-marker-alt', 'map-marker', 'map-pin', 'map-signs', 'map', 'marker', 'mars-double', 'mars-stroke-h', 'mars-stroke-v', 'mars-stroke', 'mars', 'mask', 'medal', 'medkit', 'meh-blank', 'meh-rolling-eyes', 'meh', 'memory', 'menorah', 'mercury', 'meteor', 'microchip', 'microphone-alt-slash', 'microphone-alt', 'microphone-slash', 'microphone', 'microscope', 'minus-circle', 'minus-square', 'minus', 'mitten', 'mobile-alt', 'mobile', 'money-bill-alt', 'money-bill-wave-alt', 'money-bill-wave', 'money-bill', 'money-check-alt', 'money-check', 'monument', 'moon', 'mortar-pestle', 'mosque', 'motorcycle', 'mountain', 'mouse-pointer', 'mug-hot', 'music', 'network-wired', 'neuter', 'newspaper', 'not-equal', 'notes-medical', 'object-group', 'object-ungroup', 'oil-can', 'om', 'otter', 'outdent', 'pager', 'paint-brush', 'paint-roller', 'palette', 'pallet', 'paper-plane', 'paperclip', 'parachute-box', 'paragraph', 'parking', 'passport', 'pastafarianism', 'paste', 'pause-circle', 'pause', 'paw', 'peace', 'pen-alt', 'pen-fancy', 'pen-nib', 'pen-square', 'pen', 'pencil-alt', 'pencil-ruler', 'people-carry', 'pepper-hot', 'percent', 'percentage', 'person-booth', 'phone-alt', 'phone-slash', 'phone-square-alt', 'phone-square', 'phone-volume', 'phone', 'photo-video', 'piggy-bank', 'pills', 'pizza-slice', 'place-of-worship', 'plane-arrival', 'plane-departure', 'plane', 'play-circle', 'play', 'plug', 'plus-circle', 'plus-square', 'plus', 'podcast', 'poll-h', 'poll', 'poo-storm', 'poo', 'poop', 'portrait', 'pound-sign', 'power-off', 'pray', 'praying-hands', 'prescription-bottle-alt', 'prescription-bottle', 'prescription', 'print', 'procedures', 'project-diagram', 'puzzle-piece', 'qrcode', 'question-circle', 'question', 'quidditch', 'quote-left', 'quote-right', 'quran', 'radiation-alt', 'radiation', 'rainbow', 'random', 'receipt', 'recycle', 'redo-alt', 'redo', 'registered', 'regular', 'remove-format', 'reply-all', 'reply', 'republican', 'restroom', 'retweet', 'ribbon', 'ring', 'road', 'robot', 'rocket', 'route', 'rss-square', 'rss', 'ruble-sign', 'ruler-combined', 'ruler-horizontal', 'ruler-vertical', 'ruler', 'running', 'rupee-sign', 'sad-cry', 'sad-tear', 'satellite-dish', 'satellite', 'save', 'school', 'screwdriver', 'scroll', 'sd-card', 'search-dollar', 'search-location', 'search-minus', 'search-plus', 'search', 'seedling', 'server', 'shapes', 'share-alt-square', 'share-alt', 'share-square', 'share', 'shekel-sign', 'shield-alt', 'ship', 'shipping-fast', 'shoe-prints', 'shopping-bag', 'shopping-basket', 'shopping-cart', 'shower', 'shuttle-van', 'sign-in-alt', 'sign-language', 'sign-out-alt', 'sign', 'signal', 'signature', 'sim-card', 'sitemap', 'skating', 'skiing-nordic', 'skiing', 'skull-crossbones', 'skull', 'slash', 'sleigh', 'sliders-h', 'smile-beam', 'smile-wink', 'smile', 'smog', 'smoking-ban', 'smoking', 'sms', 'snowboarding', 'snowflake', 'snowman', 'snowplow', 'socks', 'solar-panel', 'sort-alpha-down-alt', 'sort-alpha-down', 'sort-alpha-up-alt', 'sort-alpha-up', 'sort-amount-down-alt', 'sort-amount-down', 'sort-amount-up-alt', 'sort-amount-up', 'sort-down', 'sort-numeric-down-alt', 'sort-numeric-down', 'sort-numeric-up-alt', 'sort-numeric-up', 'sort-up', 'sort', 'spa', 'space-shuttle', 'spell-check', 'spider', 'spinner', 'splotch', 'spray-can', 'square-full', 'square-root-alt', 'square', 'stamp', 'star-and-crescent', 'star-half-alt', 'star-half', 'star-of-david', 'star-of-life', 'star', 'step-backward', 'step-forward', 'stethoscope', 'sticky-note', 'stop-circle', 'stop', 'stopwatch', 'store-alt', 'store', 'stream', 'street-view', 'strikethrough', 'stroopwafel', 'subscript', 'subway', 'suitcase-rolling', 'suitcase', 'sun', 'superscript', 'surprise', 'swatchbook', 'swimmer', 'swimming-pool', 'synagogue', 'sync-alt', 'sync', 'syringe', 'table-tennis', 'table', 'tablet-alt', 'tablet', 'tablets', 'tachometer-alt', 'tag', 'tags', 'tape', 'tasks', 'taxi', 'teeth-open', 'teeth', 'temperature-high', 'temperature-low', 'tenge', 'terminal', 'text-height', 'text-width', 'th-large', 'th-list', 'th', 'theater-masks', 'thermometer-empty', 'thermometer-full', 'thermometer-half', 'thermometer-quarter', 'thermometer-three-quarters', 'thermometer', 'thumbs-down', 'thumbs-up', 'thumbtack', 'ticket-alt', 'times-circle', 'times', 'tint-slash', 'tint', 'tired', 'toggle-off', 'toggle-on', 'toilet-paper', 'toilet', 'toolbox', 'tools', 'tooth', 'torah', 'torii-gate', 'tractor', 'trademark', 'traffic-light', 'train', 'tram', 'transgender-alt', 'transgender', 'trash-alt', 'trash-restore-alt', 'trash-restore', 'trash', 'tree', 'trophy', 'truck-loading', 'truck-monster', 'truck-moving', 'truck-pickup', 'truck', 'tshirt', 'tty', 'tv', 'umbrella-beach', 'umbrella', 'underline', 'undo-alt', 'undo', 'universal-access', 'university', 'unlink', 'unlock-alt', 'unlock', 'upload', 'user-alt-slash', 'user-alt', 'user-astronaut', 'user-check', 'user-circle', 'user-clock', 'user-cog', 'user-edit', 'user-friends', 'user-graduate', 'user-injured', 'user-lock', 'user-md', 'user-minus', 'user-ninja', 'user-nurse', 'user-plus', 'user-secret', 'user-shield', 'user-slash', 'user-tag', 'user-tie', 'user-times', 'user', 'users-cog', 'users', 'utensil-spoon', 'utensils', 'vector-square', 'venus-double', 'venus-mars', 'venus', 'vial', 'vials', 'video-slash', 'video', 'vihara', 'voicemail', 'volleyball-ball', 'volume-down', 'volume-mute', 'volume-off', 'volume-up', 'vote-yea', 'vr-cardboard', 'walking', 'wallet', 'warehouse', 'water', 'wave-square', 'weight-hanging', 'weight', 'wheelchair', 'wifi', 'wind', 'window-close', 'window-maximize', 'window-minimize', 'window-restore', 'wine-bottle', 'wine-glass-alt', 'wine-glass', 'won-sign', 'wrench', 'x-ray', 'yen-sign', 'yin-yang', 'brands/500px', 'brands/accessible-icon', 'brands/accusoft', 'brands/acquisitions-incorporated', 'brands/adn', 'brands/adobe', 'brands/adversal', 'brands/affiliatetheme', 'brands/airbnb', 'brands/algolia', 'brands/alipay', 'brands/amazon-pay', 'brands/amazon', 'brands/amilia', 'brands/android', 'brands/angellist', 'brands/angrycreative', 'brands/angular', 'brands/app-store-ios', 'brands/app-store', 'brands/apper', 'brands/apple-pay', 'brands/apple', 'brands/artstation', 'brands/asymmetrik', 'brands/atlassian', 'brands/audible', 'brands/autoprefixer', 'brands/avianex', 'brands/aviato', 'brands/aws', 'brands/bandcamp', 'brands/battle-net', 'brands/behance-square', 'brands/behance', 'brands/bimobject', 'brands/bitbucket', 'brands/bitcoin', 'brands/bity', 'brands/black-tie', 'brands/blackberry', 'brands/blogger-b', 'brands/blogger', 'brands/bluetooth-b', 'brands/bluetooth', 'brands/bootstrap', 'brands/btc', 'brands/buffer', 'brands/buromobelexperte', 'brands/buysellads', 'brands/canadian-maple-leaf', 'brands/cc-amazon-pay', 'brands/cc-amex', 'brands/cc-apple-pay', 'brands/cc-diners-club', 'brands/cc-discover', 'brands/cc-jcb', 'brands/cc-mastercard', 'brands/cc-paypal', 'brands/cc-stripe', 'brands/cc-visa', 'brands/centercode', 'brands/centos', 'brands/chrome', 'brands/chromecast', 'brands/cloudscale', 'brands/cloudsmith', 'brands/cloudversify', 'brands/codepen', 'brands/codiepie', 'brands/confluence', 'brands/connectdevelop', 'brands/contao', 'brands/cpanel', 'brands/creative-commons-by', 'brands/creative-commons-nc-eu', 'brands/creative-commons-nc-jp', 'brands/creative-commons-nc', 'brands/creative-commons-nd', 'brands/creative-commons-pd-alt', 'brands/creative-commons-pd', 'brands/creative-commons-remix', 'brands/creative-commons-sa', 'brands/creative-commons-sampling-plus', 'brands/creative-commons-sampling', 'brands/creative-commons-share', 'brands/creative-commons-zero', 'brands/creative-commons', 'brands/critical-role', 'brands/css3-alt', 'brands/css3', 'brands/cuttlefish', 'brands/d-and-d-beyond', 'brands/d-and-d', 'brands/dashcube', 'brands/delicious', 'brands/deploydog', 'brands/deskpro', 'brands/dev', 'brands/deviantart', 'brands/dhl', 'brands/diaspora', 'brands/digg', 'brands/digital-ocean', 'brands/discord', 'brands/discourse', 'brands/dochub', 'brands/docker', 'brands/draft2digital', 'brands/dribbble-square', 'brands/dribbble', 'brands/dropbox', 'brands/drupal', 'brands/dyalog', 'brands/earlybirds', 'brands/ebay', 'brands/edge', 'brands/elementor', 'brands/ello', 'brands/ember', 'brands/empire', 'brands/envira', 'brands/erlang', 'brands/ethereum', 'brands/etsy', 'brands/evernote', 'brands/expeditedssl', 'brands/facebook-f', 'brands/facebook-messenger', 'brands/facebook-square', 'brands/facebook', 'brands/fantasy-flight-games', 'brands/fedex', 'brands/fedora', 'brands/figma', 'brands/firefox', 'brands/first-order-alt', 'brands/first-order', 'brands/firstdraft', 'brands/flickr', 'brands/flipboard', 'brands/fly', 'brands/font-awesome-alt', 'brands/font-awesome-flag', 'brands/font-awesome', 'brands/fonticons-fi', 'brands/fonticons', 'brands/fort-awesome-alt', 'brands/fort-awesome', 'brands/forumbee', 'brands/foursquare', 'brands/free-code-camp', 'brands/freebsd', 'brands/fulcrum', 'brands/galactic-republic', 'brands/galactic-senate', 'brands/get-pocket', 'brands/gg-circle', 'brands/gg', 'brands/git-alt', 'brands/git-square', 'brands/git', 'brands/github-alt', 'brands/github-square', 'brands/github', 'brands/gitkraken', 'brands/gitlab', 'brands/gitter', 'brands/glide-g', 'brands/glide', 'brands/gofore', 'brands/goodreads-g', 'brands/goodreads', 'brands/google-drive', 'brands/google-play', 'brands/google-plus-g', 'brands/google-plus-square', 'brands/google-plus', 'brands/google-wallet', 'brands/google', 'brands/gratipay', 'brands/grav', 'brands/gripfire', 'brands/grunt', 'brands/gulp', 'brands/hacker-news-square', 'brands/hacker-news', 'brands/hackerrank', 'brands/hips', 'brands/hire-a-helper', 'brands/hooli', 'brands/hornbill', 'brands/hotjar', 'brands/houzz', 'brands/html5', 'brands/hubspot', 'brands/icons.txt', 'brands/imdb', 'brands/instagram', 'brands/intercom', 'brands/internet-explorer', 'brands/invision', 'brands/ioxhost', 'brands/itch-io', 'brands/itunes-note', 'brands/itunes', 'brands/java', 'brands/jedi-order', 'brands/jenkins', 'brands/jira', 'brands/joget', 'brands/joomla', 'brands/js-square', 'brands/js', 'brands/jsfiddle', 'brands/kaggle', 'brands/keybase', 'brands/keycdn', 'brands/kickstarter-k', 'brands/kickstarter', 'brands/korvue', 'brands/laravel', 'brands/lastfm-square', 'brands/lastfm', 'brands/leanpub', 'brands/less', 'brands/line', 'brands/linkedin-in', 'brands/linkedin', 'brands/linode', 'brands/linux', 'brands/lyft', 'brands/magento', 'brands/mailchimp', 'brands/mandalorian', 'brands/markdown', 'brands/mastodon', 'brands/maxcdn', 'brands/medapps', 'brands/medium-m', 'brands/medium', 'brands/medrt', 'brands/meetup', 'brands/megaport', 'brands/mendeley', 'brands/microsoft', 'brands/mix', 'brands/mixcloud', 'brands/mizuni', 'brands/modx', 'brands/monero', 'brands/napster', 'brands/neos', 'brands/nimblr', 'brands/node-js', 'brands/node', 'brands/npm', 'brands/ns8', 'brands/nutritionix', 'brands/odnoklassniki-square', 'brands/odnoklassniki', 'brands/old-republic', 'brands/opencart', 'brands/openid', 'brands/opera', 'brands/optin-monster', 'brands/osi', 'brands/page4', 'brands/pagelines', 'brands/palfed', 'brands/patreon', 'brands/paypal', 'brands/penny-arcade', 'brands/periscope', 'brands/phabricator', 'brands/phoenix-framework', 'brands/phoenix-squadron', 'brands/php', 'brands/pied-piper-alt', 'brands/pied-piper-hat', 'brands/pied-piper-pp', 'brands/pied-piper', 'brands/pinterest-p', 'brands/pinterest-square', 'brands/pinterest', 'brands/playstation', 'brands/product-hunt', 'brands/pushed', 'brands/python', 'brands/qq', 'brands/quinscape', 'brands/quora', 'brands/r-project', 'brands/raspberry-pi', 'brands/ravelry', 'brands/react', 'brands/reacteurope', 'brands/readme', 'brands/rebel', 'brands/red-river', 'brands/reddit-alien', 'brands/reddit-square', 'brands/reddit', 'brands/redhat', 'brands/renren', 'brands/replyd', 'brands/researchgate', 'brands/resolving', 'brands/rev', 'brands/rocketchat', 'brands/rockrms', 'brands/safari', 'brands/salesforce', 'brands/sass', 'brands/schlix', 'brands/scribd', 'brands/searchengin', 'brands/sellcast', 'brands/sellsy', 'brands/servicestack', 'brands/shirtsinbulk', 'brands/shopware', 'brands/simplybuilt', 'brands/sistrix', 'brands/sith', 'brands/sketch', 'brands/skyatlas', 'brands/skype', 'brands/slack-hash', 'brands/slack', 'brands/slideshare', 'brands/snapchat-ghost', 'brands/snapchat-square', 'brands/snapchat', 'brands/soundcloud', 'brands/sourcetree', 'brands/speakap', 'brands/speaker-deck', 'brands/spotify', 'brands/squarespace', 'brands/stack-exchange', 'brands/stack-overflow', 'brands/stackpath', 'brands/staylinked', 'brands/steam-square', 'brands/steam-symbol', 'brands/steam', 'brands/sticker-mule', 'brands/strava', 'brands/stripe-s', 'brands/stripe', 'brands/studiovinari', 'brands/stumbleupon-circle', 'brands/stumbleupon', 'brands/superpowers', 'brands/supple', 'brands/suse', 'brands/symfony', 'brands/teamspeak', 'brands/telegram-plane', 'brands/telegram', 'brands/tencent-weibo', 'brands/the-red-yeti', 'brands/themeco', 'brands/themeisle', 'brands/think-peaks', 'brands/trade-federation', 'brands/trello', 'brands/tripadvisor', 'brands/tumblr-square', 'brands/tumblr', 'brands/twitch', 'brands/twitter-square', 'brands/twitter', 'brands/typo3', 'brands/uber', 'brands/ubuntu', 'brands/uikit', 'brands/uniregistry', 'brands/untappd', 'brands/ups', 'brands/usb', 'brands/usps', 'brands/ussunnah', 'brands/vaadin', 'brands/viacoin', 'brands/viadeo-square', 'brands/viadeo', 'brands/viber', 'brands/vimeo-square', 'brands/vimeo-v', 'brands/vimeo', 'brands/vine', 'brands/vk', 'brands/vnv', 'brands/vuejs', 'brands/waze', 'brands/weebly', 'brands/weibo', 'brands/weixin', 'brands/whatsapp-square', 'brands/whatsapp', 'brands/whmcs', 'brands/wikipedia-w', 'brands/windows', 'brands/wix', 'brands/wizards-of-the-coast', 'brands/wolf-pack-battalion', 'brands/wordpress-simple', 'brands/wordpress', 'brands/wpbeginner', 'brands/wpexplorer', 'brands/wpforms', 'brands/wpressr', 'brands/xbox', 'brands/xing-square', 'brands/xing', 'brands/y-combinator', 'brands/yahoo', 'brands/yammer', 'brands/yandex-international', 'brands/yandex', 'brands/yarn', 'brands/yelp', 'brands/yoast', 'brands/youtube-square', 'brands/youtube', 'brands/zhihu', 'regular/address-book', 'regular/address-card', 'regular/angry', 'regular/arrow-alt-circle-down', 'regular/arrow-alt-circle-left', 'regular/arrow-alt-circle-right', 'regular/arrow-alt-circle-up', 'regular/bell-slash', 'regular/bell', 'regular/bookmark', 'regular/building', 'regular/calendar-alt', 'regular/calendar-check', 'regular/calendar-minus', 'regular/calendar-plus', 'regular/calendar-times', 'regular/calendar', 'regular/caret-square-down', 'regular/caret-square-left', 'regular/caret-square-right', 'regular/caret-square-up', 'regular/chart-bar', 'regular/check-circle', 'regular/check-square', 'regular/circle', 'regular/clipboard', 'regular/clock', 'regular/clone', 'regular/closed-captioning', 'regular/comment-alt', 'regular/comment-dots', 'regular/comment', 'regular/comments', 'regular/compass', 'regular/copy', 'regular/copyright', 'regular/credit-card', 'regular/dizzy', 'regular/dot-circle', 'regular/edit', 'regular/envelope-open', 'regular/envelope', 'regular/eye-slash', 'regular/eye', 'regular/file-alt', 'regular/file-archive', 'regular/file-audio', 'regular/file-code', 'regular/file-excel', 'regular/file-image', 'regular/file-pdf', 'regular/file-powerpoint', 'regular/file-video', 'regular/file-word', 'regular/file', 'regular/flag', 'regular/flushed', 'regular/folder-open', 'regular/folder', 'regular/frown-open', 'regular/frown', 'regular/futbol', 'regular/gem', 'regular/grimace', 'regular/grin-alt', 'regular/grin-beam-sweat', 'regular/grin-beam', 'regular/grin-hearts', 'regular/grin-squint-tears', 'regular/grin-squint', 'regular/grin-stars', 'regular/grin-tears', 'regular/grin-tongue-squint', 'regular/grin-tongue-wink', 'regular/grin-tongue', 'regular/grin-wink', 'regular/grin', 'regular/hand-lizard', 'regular/hand-paper', 'regular/hand-peace', 'regular/hand-point-down', 'regular/hand-point-left', 'regular/hand-point-right', 'regular/hand-point-up', 'regular/hand-pointer', 'regular/hand-rock', 'regular/hand-scissors', 'regular/hand-spock', 'regular/handshake', 'regular/hdd', 'regular/heart', 'regular/hospital', 'regular/hourglass', 'regular/id-badge', 'regular/id-card', 'regular/image', 'regular/images', 'regular/keyboard', 'regular/kiss-beam', 'regular/kiss-wink-heart', 'regular/kiss', 'regular/laugh-beam', 'regular/laugh-squint', 'regular/laugh-wink', 'regular/laugh', 'regular/lemon', 'regular/life-ring', 'regular/lightbulb', 'regular/list-alt', 'regular/map', 'regular/meh-blank', 'regular/meh-rolling-eyes', 'regular/meh', 'regular/minus-square', 'regular/money-bill-alt', 'regular/moon', 'regular/newspaper', 'regular/object-group', 'regular/object-ungroup', 'regular/paper-plane', 'regular/pause-circle', 'regular/play-circle', 'regular/plus-square', 'regular/question-circle', 'regular/registered', 'regular/sad-cry', 'regular/sad-tear', 'regular/save', 'regular/share-square', 'regular/smile-beam', 'regular/smile-wink', 'regular/smile', 'regular/snowflake', 'regular/square', 'regular/star-half', 'regular/star', 'regular/sticky-note', 'regular/stop-circle', 'regular/sun', 'regular/surprise', 'regular/thumbs-down', 'regular/thumbs-up', 'regular/times-circle', 'regular/tired', 'regular/trash-alt', 'regular/user-circle', 'regular/user', 'regular/window-close', 'regular/window-maximize', 'regular/window-minimize', 'regular/window-restore']
    };
  },
  methods: {}
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_HttpService__ = __webpack_require__(51);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sql-workbench',
  data: function data() {
    return {
      preferences: {
        showCatalogTree: true,
        catalogPaneSize: 30,
        showSavedQueries: true,
        editor: 'new'
      },
      index: 1,
      query: '',
      tabs: [],
      activeTab: 0
    };
  },
  methods: {
    viewSize: function viewSize() {
      if (this.preference.showCatalogTree === false) {
        return 100;
      } else {
        return 100 - this.preference.catalogPaneSize;
      }
    },
    onToggleCatalogTree: function onToggleCatalogTree() {
      this.preferences.showCatalogTree = !this.preferences.showCatalogTree;
      localStorage.setItem('sql.workbench.preferences', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.preferences));
    },
    onToggleSavedQueries: function onToggleSavedQueries() {
      this.preferences.showSavedQueries = !this.preferences.showSavedQueries;
      localStorage.setItem('sql.workbench.preferences', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.preferences));
    },
    onToggleEditor: function onToggleEditor() {
      if (this.preferences.editor === 'classic') {
        this.preferences.editor = 'new';
      } else {
        this.preferences.editor = 'classic';
      }
      localStorage.setItem('sql.workbench.preferences', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.preferences));
    },
    onQueryChange: function onQueryChange(query) {
      console.log('onQueryChange=' + query);
      localStorage.setItem('sql.workbench.query', this.query);
    },
    getSelectedText: function getSelectedText() {
      var start = this.$refs['query'].selectionStart;
      var end = this.$refs['query'].selectionEnd;
      if (start === end) {
        return '';
      }
      return this.query.substring(start, end);
    },
    onClear: function onClear() {
      this.query = '';
      localStorage.setItem('sql.workbench.query', this.query);
    },
    onExecuteQuery: function onExecuteQuery() {
      if (this.preferences.editor === 'new') {
        this.executeQuery(this.query);
        return;
      }
      var queryToExecute = this.getSelectedText();
      if (queryToExecute === '') {
        queryToExecute = this.query;
      }
      this.executeQuery(queryToExecute);
    },
    onCountQuery: function onCountQuery() {
      if (this.preferences.editor === 'new') {
        var _queryToExecute = 'SELECT COUNT(*) AS TOTAL FROM (' + this.query + ')';
        this.executeQuery(_queryToExecute);
        return;
      }
      var queryToExecute = this.getSelectedText();
      if (queryToExecute === '') {
        queryToExecute = this.query;
      }
      queryToExecute = 'SELECT COUNT(*) AS TOTAL FROM (' + queryToExecute + ')';
      this.executeQuery(queryToExecute);
    },
    executeQuery: function executeQuery(query) {
      var tab = {
        id: this.index++,
        name: this.index,
        type: 'query',
        sql: query,
        status: 'Pending'
      };
      this.tabs.push(tab);
    },
    prettify: function prettify() {
      var _this = this;

      var formData = new FormData();
      formData.append('query', this.query);
      __WEBPACK_IMPORTED_MODULE_1__services_HttpService__["a" /* HTTP */].post('api/query/prettify', formData).then(function (response) {
        console.log('Processing response');
        _this.query = response.data;
      });
    },
    onComplete: function onComplete(id) {
      console.log('onComplete->' + id);
      for (var tab in this.tabs) {
        if (this.tabs[tab].id === id) {
          this.activeTab = tab;
          break;
        }
      }
    },
    deleteTab: function deleteTab(id) {
      for (var tab in this.tabs) {
        if (this.tabs[tab].id === id) {
          this.tabs.splice(tab, 1);
          break;
        }
      }
    },
    onExecuteSavedQuery: function onExecuteSavedQuery(query) {
      console.log(query);
      // this.executeQuery(query.query)
      var tab = {
        id: this.index++,
        name: query.name,
        type: 'query',
        sql: query.query,
        status: 'Pending'
      };
      this.tabs.push(tab);
    },
    onCopyQuery: function onCopyQuery(query) {
      console.log(query);
      if (this.query.trim() === '') {
        this.query = query.query;
      } else {
        this.query = this.query + ';\n' + query.query;
      }
    },
    showTable: function showTable(table) {
      var tab = {
        id: this.index++,
        name: table.name,
        type: 'table',
        tableId: table.id,
        status: 'Pending'
      };
      this.tabs.push(tab);
    }
  },
  created: function created() {
    // localStorage.setItem('sql.workbench.preferences', null)
    this.query = localStorage.getItem('sql.workbench.query');
    var preferences = localStorage.getItem('sql.workbench.preferences');
    if (preferences === null || preferences === 'null') {
      console.log('Setting default preferences');
      this.preferences = {
        showCatalogTree: true,
        catalogPaneSize: 30,
        showSavedQueries: true,
        editor: 'new'
      };
    } else {
      this.preferences = JSON.parse(preferences);
    }
  }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpService__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_AuthenticationService__ = __webpack_require__(81);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ChangePassword',
  data: function data() {
    return {
      oldPassword: null,
      newPassword: null,
      verifyPassword: null
    };
  },
  methods: {
    changePassword: function changePassword(event) {
      var _this = this;

      event.preventDefault();
      var formData = new FormData();
      formData.append('oldPassword', this.oldPassword);
      formData.append('newPassword', this.newPassword);
      formData.append('verifyPassword', this.verifyPassword);
      __WEBPACK_IMPORTED_MODULE_0__services_HttpService__["a" /* HTTP */].post('api/security/password', formData).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1__services_AuthenticationService__["a" /* authenticationService */].updateCredential(_this.newPassword);
        _this.$swal({
          icon: 'success',
          title: 'Success',
          text: 'Your password has been successfully changed'
        }).then(function (response) {
          _this.$router.push({
            name: 'DashboardPage'
          });
        });
      }).catch(function (e) {
        _this.$swal({
          icon: 'error',
          title: 'Failed',
          text: 'An error occurred updating your password.'
        });
      });
    },
    cancel: function cancel() {
      this.$router.push({
        name: 'HomePage'
      });
    }
  },
  created: function created() {}
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_AuthenticationService__ = __webpack_require__(81);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      username: '',
      password: '',
      error: ''
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      if (this.username === '' || this.password === '') {
        this.error = 'Username and password is required!';
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0__services_AuthenticationService__["a" /* authenticationService */].authenticate(this.username, this.password).then(function (data) {
        console.log('authentication successful');
        _this.$router.push('/home');
      }).catch(function (e) {
        console.log('authentication error');
        _this.error = 'Invalid credentials, please try again';
        _this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Invalid credentials, please verify your username and password is correct'
        });
      });
    }
  },
  created: function created() {}
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var HTTP = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: '/',
  // baseURL: 'http://localhost:2014/',
  // baseURL: 'http://prod-master:2014/',
  headers: {
    // Authorization: 'Basic ' + credentials
  }
});

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.f68ea3d.png";

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authenticationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_HttpService__ = __webpack_require__(51);





// import router from '../router'

/**
 * AuthenticationService takes care of authenticating the user and maintaining the state the user
 * This uses the local storage for persisting the user to be able to survive page refresh.
 *
 * This also maintains a user member field to make it reactive.
 *
 * Provides isAuthenticated, getUser, authenticate and logout methods
 * This is a singleton object, created only once when the application is loaded
 */

var AuthenticationService = function () {
  /**
   * Constructor - initializes the AuthorizationService.
   *
   * This will check the local storage if a user exists.
   * If the user exists, it loads it and sets the user member field
   * This also loads the stored credentials and sets the HTTP Authorization headers globally
   * so succeeding calls do not need to set it manually
   */
  function AuthenticationService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AuthenticationService);

    // console.log('AuthenticationService() - constructor')
    this.user = null;
    // we check if the local storage contains a user
    var userJson = sessionStorage.getItem('user');
    if (userJson != null) {
      // console.log('AuthenticationService() - user found in sessionStorage =>' + userJson)
      this.user = JSON.parse(userJson);
      // console.log('AuthenticationService() - loading user credentials from storage')
      var credentials = JSON.parse(sessionStorage.getItem('credentials'));
      // console.log('AuthenticationService() - setting http authorization headers')
      __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].defaults.headers.Authorization = 'Basic ' + credentials;
    }
  }
  /**
   * This returns true if a user has authenticated
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AuthenticationService, [{
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      // console.log('AuthenticationService.isAuthenticated() => ' + (this.user != null))
      if (this.user == null) {
        return false;
      }
      return true;
    }
    /**
     * Get the current active user if available
     */

  }, {
    key: 'getUser',
    value: function getUser() {
      return this.user;
    }
    /**
     * Update the current user data
     */

  }, {
    key: 'setUser',
    value: function setUser(user) {
      this.user = user;
      sessionStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.user));
    }
    /**
     * Authenticate a user given the username and password.
     * If authentication is successful, the following actions are performed
     * 1.) Update the user member field so VueJS will be notified
     * 2.) Store the user to the local storage so we can survive a page refresh
     * 3.) Store the credentials to the local storage so we can set the authentication headers when the page is reloaded
     * 4.) Set the http authorization headers
     *
     * If the authorization fails, it throws an exception
     */

  }, {
    key: 'authenticate',
    value: function authenticate(username, password) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        // console.log('AuthenticationService.authenticate()')
        var credentials = btoa(username + ':' + password);
        // console.log('AuthenticationService.authenticate() - Credentials = ' + credentials)
        __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].post('api/security/login', {}, {
          headers: {
            Authorization: 'Basic ' + credentials
          }
        }).then(function (response) {
          // console.log('AuthenticationService.authenticate() - authenticated successfully')
          _this.user = response.data;
          // store to local storage
          // console.log('AuthenticationService.authenticate() - storing user to sessionStorage')
          sessionStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.user));
          // console.log('AuthenticationService.authenticate() - setting http authorization headers')
          __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].defaults.headers.Authorization = 'Basic ' + credentials;
          sessionStorage.setItem('credentials', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(credentials));
          resolve(_this.user);
        }).catch(function (e) {
          console.log('AuthenticationService.error=>' + e);
          reject(e);
        });
      });
    }

    /**
     * This method will logout the logged-in user
     * This following actions is performed
     * 1.) Set the user member to null to notify VueJS that the user is logged out
     * 2.) Remove the user from the local storage
     * 3.) Remove the credentials from the local storage
     */

  }, {
    key: 'logout',
    value: function logout() {
      // console.log('AuthenticationService.logout()')
      this.user = null;
      // console.log('AuthenticationService.logout() - removing user from sessionStorage')
      sessionStorage.removeItem('user', null);
      // console.log('AuthenticationService.authenticate() - removing http authorization headers')
      __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].defaults.headers.Authorization = null;
      sessionStorage.removeItem('credentials');
    }
  }, {
    key: 'updateCredential',
    value: function updateCredential(password) {
      var credentials = btoa(this.user.username + ':' + password);
      __WEBPACK_IMPORTED_MODULE_4__services_HttpService__["a" /* HTTP */].defaults.headers.Authorization = 'Basic ' + credentials;
      sessionStorage.setItem('credentials', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(credentials));
    }
    /**
     * Check if the logged-in user has the given authority. If user is not logged-in it returns false
     */

  }, {
    key: 'hasAuthority',
    value: function hasAuthority(authority) {
      if (this.user == null) {
        return false;
      }
      for (var i = 0; i < this.user.authorities.length; i++) {
        var thisAuthority = this.user.authorities[i];
        if (thisAuthority === authority) {
          return true;
        }
      }
      return false;
    }
  }]);

  return AuthenticationService;
}();

var authenticationService = new AuthenticationService();

/***/ })

},[423]);


// WEBPACK FOOTER //
// static/js/app.0deebd7cd2eaa1a33fec.js